import { AuthInfoActions } from '../constants/auth';
import { SupportActions } from '../constants/support';
import { TaskActions } from '../constants/tasks';

export const selectIsLoading = state => 
    state.common[AuthInfoActions.IsProfileLoading] ||
    state.common[TaskActions.IsTaskListsLoading] ||
    state.common[TaskActions.IsSubscribeLoading] ||
    state.common[SupportActions.IsReportLoading] ||
    state.common[SupportActions.IsResyncUserLoading];